import { FC, memo, ReactNode } from "react";
import { default as MaterialButton } from "@mui/material/Button";

import "./Button.scss";

type ButtonProps = React.ButtonHTMLAttributes<HTMLButtonElement> & {
  variant?:
    | "primary"
    | "primary-alt"
    | "secondary"
    | "warn"
    | "text"
    | "text-alt";
  size?: "medium" | "large" | "small";
  children?: React.ReactNode;
  className?: string;
  iconClassName?: string;
  testId?: string;
  startIcon?: ReactNode;
  onClick: (event: React.MouseEvent<HTMLButtonElement, MouseEvent>) => void;
  disabled?: boolean;
};
const Button: FC<ButtonProps> = ({
  variant = "primary",
  size = "medium",
  type = "submit",
  children,
  className = "",
  iconClassName = "",
  testId = "",
  startIcon = "",
  onClick,
  disabled
}: ButtonProps) => {
  const getVariant = () => {
    if (
      variant === "primary" ||
      variant === "primary-alt" ||
      variant === "secondary" ||
      variant === "warn"
    ) {
      return "outlined";
    } else if (variant === "text-alt") {
      return "contained";
    } else {
      return "text";
    }
  };

  return (
    <MaterialButton
      variant={getVariant()}
      size={size}
      type={type}
      className={
        variant === "primary"
          ? `${className} btn-primary`
          : variant === "secondary"
          ? `${className} btn-secondary`
          : variant === "warn"
          ? `${className} btn-warn`
          : "btn-others"
      }
      onClick={onClick}
      data-test-id={testId}
      disabled={disabled}
      startIcon={startIcon}
      sx={{ textTransform: "none" }}
    >
      {children}
    </MaterialButton>
  );
};

export default memo(Button);
